// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__product___pZTsR {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: white;
  margin-bottom: 30px;
  width: 100%;
  flex: 1 1 100%;
}
@media (min-width: 991px) {
  .styles__product___pZTsR {
    width: 25%;
    flex: 0 0 calc((100% - 90px) / 4);
  }
}
.styles__flexCenter___LkFZb {
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles__productThumbnail___d4sOy {
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;
  text-align: center;
  cursor: pointer;
  position: relative;
  display: flex;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.05);
}
.styles__productThumbnail___d4sOy > div {
  margin: 0 auto;
}
.styles__productThumbnail___d4sOy > img {
  min-height: 120px;
}
.styles__productMainDetailsWrapper___ZcDDD {
  padding: 20px 20px 0 20px;
  min-height: 145px;
}
.styles__productMainDetailsWrapper___ZcDDD .styles__productProperties___UoYHZ {
  line-height: 14px;
}
.styles__productTitleWrapper___M7eUI {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
.styles__productTitle___ak_t9 {
  font-weight: 400;
  font-size: 18px;
  text-overflow: ellipsis;
  display: table;
  table-layout: fixed;
  width: 100%;
  text-decoration: none;
  text-align: left;
}
.styles__productTitle___ak_t9 > span {
  display: table-row;
  font-size: 1.05em;
  font-weight: bolder;
}
.styles__productTitle___ak_t9 span span {
  display: table-cell;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.styles__productTitle___ak_t9 em {
  display: table-cell;
  font-size: 0.75em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-style: normal;
  font-weight: bold;
  box-sizing: border-box;
  padding: 0;
}
.styles__productDimensions___nQucw {
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-self: center;
  align-self: flex-start;
  font-size: 0.9em;
  font-weight: bold;
}
.styles__characteristicsTitle___JdOKj {
  width: 100%;
  border-bottom: 1px solid #d8d8d8;
  font-size: 14px;
}
.styles__characteristicsSection_____bL9 {
  padding-top: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #d8d8d8;
}
.styles__characteristicsSection_____bL9:last-child {
  border-bottom: none;
}
.styles__button___xLsoA {
  width: 100%;
  height: 48px;
  max-height: 40px;
}
.styles__button___xLsoA > span:first-child {
  padding-right: 6px;
}
@media (max-width: 991px) {
  .styles__button___xLsoA {
    width: 100%;
    height: 48px;
  }
}
.styles__produdctTitleWrapper___q4rnA {
  padding: 20px 20px 0 20px;
}
.styles__content___YLEiV {
  padding: 0 20px;
}
.styles__content___YLEiV .col-xs-6:nth-child(2) {
  font-weight: bold;
  word-wrap: break-word;
}
.styles__cart___GJTCb {
  margin-top: auto;
}
.styles__buttonWrapper___EWfGs {
  width: 100%;
  padding: 0 20px 20px 20px;
}
.styles__noteWrapper___uc14q {
  width: 100%;
  padding: 6px 20px 12px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.styles__noteWrapper___uc14q > div {
  flex-grow: 1;
}
.styles__input___HvOga {
  border: none !important;
  border-bottom: 1px solid grey !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.styles__accentedCell___hUHdJ {
  padding-top: 10px;
  padding-bottom: 10px;
}
.styles__commentInput___u70wj {
  border: none !important;
  box-shadow: none !important;
}
.styles__propertyTitle___b2eUU {
  font-size: 12px;
  color: #7F7F7F;
}
.styles__priceInfo___AMSxL {
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
}
.styles__priceInfo___AMSxL .styles__price___tZ9LJ {
  font-size: 20px;
  font-weight: bold;
}
.styles__priceInfo___AMSxL .styles__pricePcs___w_mj2 {
  display: block;
  font-size: 14px;
}
@media (max-width: 991px) {
  .styles__priceInfo___AMSxL {
    padding: 0px;
  }
}
.styles__orderInfo___ZZha9 {
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 12px 20px;
}
.styles__orderInfo___ZZha9 .styles__orderInfoItem___VyzXh {
  position: relative;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 991px) {
  .styles__orderInfo___ZZha9 .styles__orderInfoItem___VyzXh {
    align-items: flex-start;
    flex-direction: column;
  }
}
.styles__orderInfo___ZZha9 .styles__orderInfoItem___VyzXh .styles__quantityWrapper___oGigm {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.styles__orderInfo___ZZha9 .styles__orderInfoItem___VyzXh .styles__quantityWrapper___oGigm > span:first-child {
  margin-right: 0.5em;
}
.styles__orderInfo___ZZha9 .styles__orderInfoItem___VyzXh .styles__quantityWrapper___oGigm > span:last-child {
  border: 1px solid #ccc !important;
  padding: 0;
}
.styles__orderInfo___ZZha9 .styles__orderInfoItem___VyzXh .styles__quantityWrapper___oGigm > span:last-child input {
  padding: 2px 2px 2px 6px;
  height: 1.65em;
}
.styles__quantityInCart___wIhyt {
  text-align: right;
}
.styles__price___tZ9LJ {
  margin-right: 4px;
}
.styles__comment___jHZLD {
  margin-bottom: 10px;
  margin-top: 10px;
  color: #D9534F;
}
.styles__limitedQuantityMessage___jxvlh {
  color: #d9534f;
}
.styles__wheelLoad___L9R8m {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.styles__wheelLoad___L9R8m > span {
  padding-right: 0.5em;
}
.styles__orange___cKcfh {
  color: darkorange;
}
.styles__red___IU4fN {
  color: darkred;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Search/SearchResults/ProductsList/RimProduct/styles.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AADF;AAGE;EAAA;IACE,UAAA;IACA,iCAAA;EAAF;AACF;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAIA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;AAFF;AAPA;EAWI,cAAA;AADJ;AAVA;EAeI,iBAAA;AAFJ;AAMA;EACE,yBAAA;EACA,iBAAA;AAJF;AAEA;EAMI,iBAAA;AALJ;AASA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAPF;AAUA;EACE,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;AARF;AAAA;EAWI,kBAAA;EACA,iBAAA;EACA,mBAAA;AARJ;AALA;EAiBI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AATJ;AAXA;EAwBI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;AAXJ;AAeA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AAbF;AAgBA;EACE,WAAA;EACA,gCAAA;EACA,eAAA;AAdF;AAiBA;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;AAfF;AAkBA;EACE,mBAAA;AAhBF;AAmBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAjBF;AAcA;EAMI,kBAAA;AAjBJ;AAoBE;EAAA;IACE,WAAA;IACA,YAAA;EAjBF;AACF;AAoBA;EACE,yBAAA;AAlBF;AAqBA;EACE,eAAA;AAnBF;AAkBA;EAII,iBAAA;EACA,qBAAA;AAnBJ;AAuBA;EACE,gBAAA;AArBF;AAwBA;EACE,WAAA;EACA,yBAAA;AAtBF;AAyBA;EACE,WAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAvBF;AAiBA;EASI,YAAA;AAvBJ;AA2BA;EACE,uBAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;AAzBF;AA4BA;EACE,iBAAA;EACA,oBAAA;AA1BF;AA6BA;EACE,uBAAA;EACA,2BAAA;AA3BF;AA8BA;EACE,eAAA;EACA,cAAA;AA5BF;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AA7BF;AAyBA;EAOI,eAAA;EACA,iBAAA;AA7BJ;AAqBA;EAYI,cAAA;EACA,eAAA;AA9BJ;AAiCE;EAAA;IACE,YAAA;EA9BF;AACF;AAiCA;EACE,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;AA/BF;AAuBA;EAWI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA/BJ;AAiCI;EAAA;IACE,uBAAA;IACA,sBAAA;EA9BJ;AACF;AASA;EAyBM,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AA/BN;AAGA;EA+BQ,mBAAA;AA/BR;AAAA;EAmCQ,iCAAA;EACA,UAAA;AAhCR;AAJA;EAuCU,wBAAA;EACA,cAAA;AAhCV;AAuCA;EACE,iBAAA;AArCF;AAwCA;EACE,iBAAA;AAtCF;AAyCA;EAEE,mBAAA;EACA,gBAAA;EACA,cAAA;AAvCF;AA0CA;EACE,cAAA;AAxCF;AA2CA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAzCF;AAsCA;EAMI,oBAAA;AAzCJ;AA6CA;EACE,iBAAA;AA3CF;AA8CA;EACE,cAAA;AA5CF","sourcesContent":["@import '../../../../../../shared/variables.less';\n\n.product {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: white;\n  margin-bottom: 30px;\n  width: 100%;\n  flex: 1 1 100%;\n\n  @media (min-width: @screen-sm-max) {\n    width: 25%;\n    flex: 0 0 calc((100% - 90px) / 4);\n  }\n}\n\n.flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.productThumbnail {\n  width: 100%;\n  margin: 0 auto;\n  padding: 10px 0;\n  text-align: center;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  box-sizing: border-box;\n  background: rgba(0,0,0,0.05);\n  > div {\n    margin: 0 auto;\n  }\n\n  > img {\n    min-height: 120px;\n  }\n}\n\n.productMainDetailsWrapper {\n  padding: 20px 20px 0 20px;\n  min-height: 145px;\n\n\n  .productProperties {\n    line-height: 14px;\n  }\n}\n\n.productTitleWrapper {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 8px;\n}\n\n.productTitle {\n  font-weight: 400;\n  font-size: 18px;\n  text-overflow: ellipsis;\n  display: table;\n  table-layout: fixed;\n  width: 100%;\n  text-decoration: none;\n  text-align: left;\n\n  > span {\n    display: table-row;\n    font-size: 1.05em;\n    font-weight: bolder;\n  }\n\n  span span {\n    display: table-cell;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  em {\n    display: table-cell;\n    font-size: 0.75em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    // white-space: nowrap;\n    font-style: normal;\n    font-weight: bold;\n    box-sizing: border-box;\n    padding: 0;\n  }\n}\n\n.productDimensions {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  justify-self: center;\n  align-self: flex-start;\n  font-size: 0.9em;\n  font-weight: bold;\n}\n\n.characteristicsTitle {\n  width: 100%;\n  border-bottom: 1px solid #d8d8d8;\n  font-size: 14px;\n}\n\n.characteristicsSection {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #d8d8d8;\n}\n\n.characteristicsSection:last-child {\n  border-bottom: none;\n}\n\n.button {\n  width: 100%;\n  height: 48px;\n  max-height: 40px;\n\n  > span:first-child {\n    padding-right: 6px;\n  }\n\n  @media (max-width: @screen-sm-max) {\n    width: 100%;\n    height: 48px;\n  }\n}\n\n.produdctTitleWrapper {\n  padding: 20px 20px 0 20px;\n}\n\n.content {\n  padding: 0 20px;\n\n  :global(.col-xs-6:nth-child(2)) {\n    font-weight: bold;\n    word-wrap: break-word;\n  }\n}\n\n.cart {\n  margin-top: auto;\n}\n\n.buttonWrapper {\n  width: 100%;\n  padding: 0 20px 20px 20px;\n}\n\n.noteWrapper {\n  width: 100%;\n  padding: 6px 20px 12px 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n\n  > div {\n    flex-grow: 1;\n  }\n}\n\n.input {\n  border: none !important;\n  border-bottom: 1px solid grey !important;\n  box-shadow: none !important;\n  background-color: transparent !important;\n}\n\n.accentedCell {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.commentInput {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.propertyTitle {\n  font-size: 12px;\n  color: @eon-text-color-muted;\n}\n\n.priceInfo {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  white-space: nowrap;\n\n  .price {\n    font-size: 20px;\n    font-weight: bold;\n  }\n\n  .pricePcs {\n    display: block;\n    font-size: 14px;\n  }\n\n  @media (max-width: 991px) {\n    padding: 0px;\n  }\n}\n\n.orderInfo {\n  border-left: none !important;\n  border-right: none !important;\n  border-bottom: none !important;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 20px 12px 20px;\n\n  .orderInfoItem {\n    position: relative;\n    width: 100%;\n    padding: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    @media (max-width: 991px) {\n      align-items: flex-start;\n      flex-direction: column;\n    }\n\n    .quantityWrapper {\n      // flex: 0 0 auto;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n\n      > span:first-child {\n        margin-right: 0.5em;\n      }\n\n      > span:last-child {\n        border: 1px solid #ccc !important;\n        padding: 0;\n\n        input {\n          padding: 2px 2px 2px 6px;\n          height: 1.65em;\n        }\n      }\n    }\n  }\n}\n\n.quantityInCart {\n  text-align: right;\n}\n\n.price {\n  margin-right: 4px;\n}\n\n.comment {\n  composes: flexCenter;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  color: @eon-text-color-red;\n}\n\n.limitedQuantityMessage {\n  color: @danger;\n}\n\n.wheelLoad {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  > span {\n    padding-right: 0.5em;\n  }\n}\n\n.orange {\n  color: darkorange;\n}\n\n.red {\n  color: darkred;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product": `styles__product___pZTsR`,
	"flexCenter": `styles__flexCenter___LkFZb`,
	"productThumbnail": `styles__productThumbnail___d4sOy`,
	"productMainDetailsWrapper": `styles__productMainDetailsWrapper___ZcDDD`,
	"productProperties": `styles__productProperties___UoYHZ`,
	"productTitleWrapper": `styles__productTitleWrapper___M7eUI`,
	"productTitle": `styles__productTitle___ak_t9`,
	"productDimensions": `styles__productDimensions___nQucw`,
	"characteristicsTitle": `styles__characteristicsTitle___JdOKj`,
	"characteristicsSection": `styles__characteristicsSection_____bL9`,
	"button": `styles__button___xLsoA`,
	"produdctTitleWrapper": `styles__produdctTitleWrapper___q4rnA`,
	"content": `styles__content___YLEiV`,
	"cart": `styles__cart___GJTCb`,
	"buttonWrapper": `styles__buttonWrapper___EWfGs`,
	"noteWrapper": `styles__noteWrapper___uc14q`,
	"input": `styles__input___HvOga`,
	"accentedCell": `styles__accentedCell___hUHdJ`,
	"commentInput": `styles__commentInput___u70wj`,
	"propertyTitle": `styles__propertyTitle___b2eUU`,
	"priceInfo": `styles__priceInfo___AMSxL`,
	"price": `styles__price___tZ9LJ`,
	"pricePcs": `styles__pricePcs___w_mj2`,
	"orderInfo": `styles__orderInfo___ZZha9`,
	"orderInfoItem": `styles__orderInfoItem___VyzXh`,
	"quantityWrapper": `styles__quantityWrapper___oGigm`,
	"quantityInCart": `styles__quantityInCart___wIhyt`,
	"comment": `styles__comment___jHZLD styles__flexCenter___LkFZb`,
	"limitedQuantityMessage": `styles__limitedQuantityMessage___jxvlh`,
	"wheelLoad": `styles__wheelLoad___L9R8m`,
	"orange": `styles__orange___cKcfh`,
	"red": `styles__red___IU4fN`
};
export default ___CSS_LOADER_EXPORT___;
